<template>
  <div>
    <title>退货管理</title>
    <section class="mainPart" v-if="userInfo">
      <header class="tabHeader" v-show="userInfo.isopenfinancial&&userInfo.isopensale">
        <p>
          <a :class="{'isActive':refundType == 1}" @click="refundType = 1">退货申请列表</a>
          <a :class="{'isActive':refundType == 0}" @click="refundType = 0">退货审核列表</a>
        </p>
      </header>
      <RefundInfo :key="refreshnum" :refundType="refundType" :enterWay="(userInfo.isopenfinancial&&userInfo.isopensale)?0:1"></RefundInfo>
    </section>
  </div>
</template>
<script>
import { Message, MessageBox } from "element-ui";
export default {
  name: "RefundManagement",
  data() {
    return {
      refreshnum: 1,
      refundType: 1,
      userInfo: '', // 登录信息
    };
  },
  filters: {},
  components: {
    RefundInfo: resolve =>
      require(["@/components/OrderFolder/StoreSale/RefundInfo.vue"], resolve) //退款申请组件
  },
  methods: {},
  created() {
    if(localStorage.getItem('userInfoMd')&&localStorage.getItem('userInfoMd')!=undefined) {
      this.userInfo = JSON.parse(localStorage.getItem('userInfoMd'));
      this.refreshnum = this.userInfo.isopensale?1:0;
      this.refundType = this.userInfo.isopensale?1:0;
    }
  },
  watch: {
    refundType: {
      handler: function() {
        this.refreshnum++;
      }
    }
  },
  mounted() {
    
  },
  computed: {}
};
</script>

<style scoped>
@import "Css/Style.css";
</style>



// WEBPACK FOOTER //
// src/views/OrderFolder/StoreSale/RefundManagement.vue